import {
  UserManagementApi,
  useAPIQueryAndQueryKey,
} from "melco-shared-logic";

export const useUser = (
  userId: string,

) => {
  //const token = useUserToken();
  //const baseApiConfig = useBaseAPIConfig();
  //const api = new UserManagementApi(baseApiConfig({ token }));

  return useAPIQueryAndQueryKey(
    UserManagementApi,
    ["user", userId,],
    async (api) =>
      api.userGetUser({ id: userId })
  );
};
